module.exports = __webpack_public_path__ + "static/media/mir.e20f6688.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/TransactionsTable/images/mir.svg
// module id = 655
// module chunks = 0